import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Flame, Layers, LogOut } from 'lucide-react';
import './ModuleSelection.css';

const ModuleSelection = () => {
    const navigate = useNavigate();
    const currentUser = localStorage.getItem('currentUser') || 'User';

    let accessibleModules = ['CU', 'FE'];
    try {
        const stored = localStorage.getItem('accessibleModules');
        if (stored) accessibleModules = JSON.parse(stored);
    } catch (e) {
        accessibleModules = ['CU', 'FE'];
    }

    React.useEffect(() => {
        if (Array.isArray(accessibleModules) && accessibleModules.length === 1) {
            localStorage.setItem('userModule', accessibleModules[0]);
            navigate('/dashboard', { replace: true });
        }
    }, [accessibleModules, navigate]);

    const handleSelectModule = (moduleCode) => {
        localStorage.setItem('userModule', moduleCode);
        navigate('/dashboard');
    };

    const handleLogout = () => {
        localStorage.clear();
        navigate('/login');
    };

    return (
        <div className="selection-container">
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="selection-box glass-panel"
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <span style={{ fontSize: '14px', color: 'var(--text-secondary)' }}>
                        Logged in as <strong style={{ color: 'var(--text-primary)' }}>{currentUser}</strong>
                    </span>
                    <button onClick={handleLogout} className="btn-secondary" style={{ padding: '6px 12px', fontSize: '13px' }}>
                        <LogOut size={14} /> Logout
                    </button>
                </div>

                <div className="selection-header">
                    <p>Please select the calculator module to continue.</p>
                </div>

                <div className="cards-wrapper">
                    {accessibleModules.includes('CU') && (
                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.98 }}
                            className="selection-card glass-panel"
                            onClick={() => handleSelectModule('CU')}
                        >
                            <div className="card-symbol cu">
                                <Flame size={32} />
                            </div>
                            <h3>Copper (Cu)</h3>
                            {/* <p>Copper & Brass Metallurgy Charge Calculation Module</p> */}
                            <button className="btn-primary card-btn">
                                Open Copper Module <ArrowRight size={16} />
                            </button>
                        </motion.div>
                    )}

                    {accessibleModules.includes('FE') && (
                        <motion.div
                            whileHover={{ scale: 1.03 }}
                            whileTap={{ scale: 0.98 }}
                            className="selection-card glass-panel"
                            onClick={() => handleSelectModule('FE')}
                        >
                            <div className="card-symbol fe">
                                <Layers size={32} />
                            </div>
                            <h3>Iron (Fe)</h3>
                            {/* <p>Iron & Ferrous Alloy Charge Calculation Module</p> */}
                            <button className="btn-primary card-btn">
                                Open Iron Module <ArrowRight size={16} />
                            </button>
                        </motion.div>
                    )}
                </div>
            </motion.div>
        </div>
    );
};

export default ModuleSelection;
